import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("paging-element")
export class Paging extends LitElement {
  @property()
  accessor currentPage: number = 0;
  @property()
  accessor totalPages: number = 0;

  @property()
  accessor dictionary: any = {};

  createRenderRoot() {
    return this;
  }

  handlePageChange(newPage: number) {
    console.log("handlePageChange:" + newPage);

    this.currentPage = newPage;
    const event = new CustomEvent("page-change", {
      detail: { currentPage: newPage },
      bubbles: true, // Allows the event to bubble up to parent elements
      composed: true, // Allows the event to pass through shadow DOM boundaries
    });

    this.dispatchEvent(event);
  }

  onPagingBackClick() {
    const newPage = Number(this.currentPage) - 1;
    console.log("onPagingBackClick:" + newPage);
    if (newPage >= 0) {
      this.handlePageChange(newPage);
    }
  }
  onPagingForwardClick() {
    console.log(this.currentPage);
    console.log(isNaN(this.currentPage));
    console.log(typeof this.currentPage);
    const newPage = Number(this.currentPage) + 1;
    console.log("onPagingForwardClick:" + newPage);
    if (newPage < this.totalPages) {
      this.handlePageChange(newPage);
    }
  }

  renderBackButton() {
    if (Number(this.currentPage) > 0) {
      return html`<button
        type="button"
        class="bg-dark-blue-100 text-light-grey-10 rounded-xs py-2.5 px-4 min-h-11 min-w-14 md:min-w-16 text-center"
        @click="${() => this.onPagingBackClick()}"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27"
          height="22"
          viewBox="0 0 27 22"
          fill="none"
          class="-scale-100"
        >
          <path
            d="M15.6013 21.8866H11.9388L21.3745 12.3365L0.25 12.3365L0.25 9.66342L21.3745 9.66342L11.9388 0.113281L15.6013 0.113281L26.378 11L15.6013 21.8866Z"
            fill="currentColor"
          />
        </svg>
      </button>`;
    }
    return html``;
  }
  renderForwardButton() {
    if (Number(this.currentPage) < Number(this.totalPages - 1)) {
      return html`<button
        type="button"
        class="bg-dark-blue-100 text-light-grey-10 rounded-xs py-2.5 px-4 min-h-11 min-w-14 md:min-w-16 text-center"
        @click="${() => this.onPagingForwardClick()}"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27"
          height="22"
          viewBox="0 0 27 22"
          fill="none"
        >
          <path
            d="M15.6013 21.8866H11.9388L21.3745 12.3365L0.25 12.3365L0.25 9.66342L21.3745 9.66342L11.9388 0.113281L15.6013 0.113281L26.378 11L15.6013 21.8866Z"
            fill="currentColor"
          />
        </svg>
      </button>`;
    }
    return html``;
  }
  renderNumberButton(num: number) {
    return html`<button
      type="button"
      @click="${() => this.handlePageChange(num)}"
      class="${Number(this.currentPage) === num
        ? "bg-blue-15 text-dark-blue-100"
        : "bg-dark-blue-100 text-light-grey-10"} 
      text-[1.375rem] min-h-11 min-w-14 md:min-w-16 text-center border-dark-blue-100 border rounded-xs py-1 px-4
      "
    >
      ${num + 1}
    </button>`;
  }

  renderEllipsis() {
    return html`<span
      class="text-[1.375rem] block min-h-11 min-w-14 md:min-w-16 text-center bg-medium-blue-100 text-light-grey-10 border-dark-blue-100 border rounded-xs py-1 px-4"
      >...</span
    >`;
  }

  renderNumberButtons() {
    const maxVisibleButtons = 4; // Maximum number of page buttons displayed, excluding ellipses
    const buttons = [];

    if (Number(this.totalPages) <= maxVisibleButtons) {
      // If total pages are less than or equal to maxVisibleButtons, show all page numbers
      for (let i = 0; i < this.totalPages; i++) {
        buttons.push(this.renderNumberButton(i));
      }
      return buttons;
    }

    // Always show the first page button
    buttons.push(this.renderNumberButton(0)); // Page 1

    const visibleRange = maxVisibleButtons - 2; // Reserve space for first and last pages
    const halfRange = Math.floor(visibleRange / 2);
    let start = Math.max(1, this.currentPage - halfRange);
    let end = Math.min(this.totalPages - 2, this.currentPage + halfRange);

    // Adjust start and end if they overflow the boundaries
    if (this.currentPage <= halfRange) {
      start = 1;
      end = visibleRange;
    } else if (this.currentPage + halfRange >= this.totalPages - 1) {
      start = this.totalPages - 1 - visibleRange;
      end = this.totalPages - 2;
    }

    // Add ellipsis if there are skipped pages before the start
    if (start > 1) {
      buttons.push(this.renderEllipsis());
    }

    // Render the middle page buttons
    for (let i = start; i <= end; i++) {
      buttons.push(this.renderNumberButton(i));
    }

    // Add ellipsis if there are skipped pages after the end
    if (end < this.totalPages - 2) {
      buttons.push(this.renderEllipsis());
    }

    // Always show the last page button
    buttons.push(this.renderNumberButton(this.totalPages - 1)); // Last Page

    return buttons;
  }

  render() {
    if (this.totalPages === 0 || this.totalPages === null) {
      return html``;
    }
    return html`
      <div
        class="pagination max-w-site-maxwidth mx-auto flex justify-center items-center gap-2 site-gutter"
      >
        ${this.renderBackButton()}
        <div class="text-dark-blue-100 p font-medium">
          ${Number(this.currentPage) + 1}
          ${JSON.parse(this.dictionary)["of"] ?? ""} ${Number(this.totalPages)}
        </div>
        ${this.renderForwardButton()}
      </div>
    `;
  }
}
